import { useDispatch, useSelector } from 'react-redux';
import { POST_DETAILS } from '../constants';
import { useTranslate } from '@tolgee/react';
import { setRightMenuOpen } from '../../../redux/slices/communication';
import { useEffect, useState } from 'react';
import { getImageUrl } from '../../../firebase/utils';
import { useLocales } from '../../../locales';
import { PLATFORM_STATIC_ICONS_PNG } from '../../../config/icons';

export default function PostDetails() {
  const { currentLang } = useLocales();
  const { t } = useTranslate();
  const {
    data: { activeConversation },
    isLoading
  } = useSelector((state) => state.communication);

  const compnentName = POST_DETAILS;
  const {
    ui: { rightMenuOpen }
  } = useSelector((state) => state.communication);
  const [imageUrl, setImage] = useState(
    activeConversation?.post_data?.preview_image_url
      ? activeConversation?.post_data?.preview_image_url
      : getImageUrl(activeConversation?.post_data?.preview_image_file).then(
          (url) => setImage(url)
        )
  );

  useEffect(() => {
    if (activeConversation?.post_data?.preview_image_url) {
      setImage(activeConversation?.post_data?.preview_image_url);
    } else {
      getImageUrl(activeConversation?.post_data?.preview_image_file).then(
        (url) => setImage(url)
      );
    }
  }, [activeConversation]);

  const dispatch = useDispatch();
  if (rightMenuOpen !== compnentName || !activeConversation) return null;
  const handleClick = (e) => {
    if (rightMenuOpen) dispatch(setRightMenuOpen(null));
  };

  //  if (leftMenuOpen !== componentName) return null;
  if (!activeConversation && !isLoading)
    return (
      <div
        className="card p-3 d-flex  align-items-center position-relative h-100"
        style={{ width: 300 }}
      >
        <i
          className="fa-duotone fa-left-to-line position-absolute cursor-pointer start-0 top-0"
          onClick={handleClick}
        ></i>
        <p className="fw-bold text-muted text-align-center">
          {t('communication.postDetails.post')}
        </p>
        <div className="mt-5" />
        <p> {t('communication.postDetails.no_conversation_seleted')}</p>
      </div>
    );
  return (
    <div className="position-relative ">
      <div
        className="card p-3 d-flex  align-items-center shadow overflow-auto"
        style={{
          minWidth: 400,
          position: 'absolute',
          height: '100%',
          top: 0,
          right: 10,
          maxWidth: 400,
          zIndex: 999
        }}
      >
        <i
          className="fa-duotone fa-left-to-line  cursor-pointer position-absolute start-0 top-0 m-3"
          onClick={handleClick}
        ></i>
        <p className="fw-bold text-muted text-align-center">
          {t('communication.postDetails.post')}
        </p>
        <div className="mt-2" />
        <div className="card m-2 p-5 shadow d-flex flex-row justify-content-between w-100 align-items-center container position-relative">
          <div className="">
            <img
              src={PLATFORM_STATIC_ICONS_PNG[activeConversation.platform]}
              className="h-40px w-40px"
            />
          </div>
          <div className="">
            <p className="fw-bold m-0">{t(activeConversation.platform)}</p>
            <p className="fw-bold text-muted m-0">{t('post')}</p>
          </div>
          <div className="col-4" />
          <div
            className="text-muted p-1"
            style={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              width: 'fit-content'
            }}
          >
            {new Date(
              activeConversation?.post_data?.publication_date
            ).toLocaleDateString(currentLang.value, {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </div>
        </div>
        <div className="mt-2" />
        <div className="card m-2 p-5 shadow w-100">
          <img
            src={imageUrl}
            className="rounded "
            style={{
              width: '100%',
              objectFit: 'cover'
            }}
          />
          <div className="mt-2" />
          <div
            style={{ whiteSpace: 'normal', fontWeight: 500 }}
            dangerouslySetInnerHTML={{
              __html: activeConversation?.post_data?.text_as_html
            }}
          ></div>
          <div className="mt-2" />
          <div className="d-flex justify-content-end text-muted">
            {new Date(
              activeConversation?.post_data?.publication_date
            ).toLocaleDateString(currentLang.value, {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
